import {
  Box,
  Typography,
  IconButton,
  FormGroup,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import TextInput from "../../../../../../components/textinput/textinput";

type Props = {
  formik: any;
  certificationMethods: any[];
  uploadedCertificate: any;
  handleCertificateFileChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  handleCertificateFileDelete: () => void;
  setUploadedCertificate: (value: any) => void;
  setDeleteCertificate: (value: boolean) => void;
  selectedCertificateFile: any;
  onCertificationMethodChange?: (method: string) => void;
  data: any;
};

const FreddieMac = (props: Props) => {
  const {
    formik,
    certificationMethods,
    uploadedCertificate,
    handleCertificateFileChange,
    handleCertificateFileDelete,
    setUploadedCertificate,
    setDeleteCertificate,
    selectedCertificateFile,
    data,
  } = props;

  const freddieMacCertificationMethods = certificationMethods.filter(
    (type: any) => type.certificationType === "FreddieMac"
  );

  return (
    <Box sx={{ pl: "36px", mt: "10px" }}>
      <FormGroup>
        <Box
          sx={{
            border: formik.values.isFreddieMacExemptInspector
              ? "1px solid"
              : "1px solid grey",
            borderColor: formik.values.isFreddieMacExemptInspector
              ? "primary.main"
              : "grey",
            borderRadius: "8px",
            p:
              formik.values.isFreddieMacExemptInspector ||
              (!formik.values.isFreddieMacExemptInspector &&
                !formik.values.isCertifiedInspector)
                ? 1
                : "2px 4px",
            mb: 2,
            backgroundColor: formik.values.isFreddieMacExemptInspector
              ? "#E35F000A"
              : "white",
            maxWidth: "1034px !important",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={formik.values.isFreddieMacExemptInspector}
                onChange={(event) => {
                  formik.setFieldValue(
                    "isFreddieMacExemptInspector",
                    event.target.checked
                  );
                }}
              />
            }
            label="Exempt Inspector"
          />
          {(formik.values.isFreddieMacExemptInspector ||
            (!formik.values.isFreddieMacExemptInspector &&
              !formik.values.isCertifiedInspector)) && (
            <Box sx={{ pl: 4 }}>
              <Typography
                sx={{ fontSize: "0.875rem", color: "text.secondary" }}
              >
                The Inspector must meet ALL of the following conditions:
              </Typography>
              <ul
                style={{
                  lineHeight: "1.5",
                  letterSpacing: "0.15px",
                  paddingLeft: "24px",
                }}
              >
                <li>
                  <Typography>
                    Completed at least <b>100 multifamily asset inspections</b>{" "}
                    comparable to Freddie Mac’s Property Inspections
                  </Typography>
                </li>
                <li>
                  <Typography>
                    At least{" "}
                    <b>5 years experience peforming multifamily inspections</b>{" "}
                    comparable to Freddie Mac’s Property Inspections
                  </Typography>
                </li>
                <li>
                  <Typography>
                    Meets the qualifications for a property condition consultant
                    set forth in{" "}
                    <span style={{ color: "#E35F00", fontWeight: "bold" }}>
                      Section 62.8
                    </span>{" "}
                    or{" "}
                    <span style={{ color: "#E35F00", fontWeight: "bold" }}>
                      Section 62SBL.17
                    </span>
                    , as applicable, of the Multifamily Seller/Servicer Guide.
                  </Typography>
                </li>
              </ul>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            maxWidth: "1034px !important",
            border: formik.values.isCertifiedInspector
              ? "1px solid"
              : "1px solid grey",
            borderColor: formik.values.isCertifiedInspector
              ? "primary.main"
              : "grey",
            borderRadius: "8px",
            p:
              formik.values.isCertifiedInspector ||
              (!formik.values.isFreddieMacExemptInspector &&
                !formik.values.isCertifiedInspector)
                ? 1
                : "2px 4px",
            mb: 0.25,
            backgroundColor: formik.values.isCertifiedInspector
              ? "#E35F000A"
              : "white",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={formik.values.isCertifiedInspector}
                onChange={(event) => {
                  formik.setFieldValue(
                    "isCertifiedInspector",
                    event.target.checked
                  );
                  if (!event.target.checked) {
                    formik.setFieldValue("certificationMethod", "");
                    formik.setFieldValue("otherCertificationMethod", "");
                    formik.setFieldValue("certificate", "");
                    if (data?.certificateFileName) {
                      setDeleteCertificate(true);
                    }
                  }
                }}
              />
            }
            label="Certified Inspector"
          />

          {(formik.values.isCertifiedInspector ||
            (!formik.values.isFreddieMacExemptInspector &&
              !formik.values.isCertifiedInspector)) && (
            <Box sx={{ pl: 4, mt: 1, mb: 2 }}>
              <Typography
                sx={{ fontSize: "0.875rem", color: "text.secondary" }}
              >
                The Inspector must meet ALL of the following conditions:
              </Typography>
              <ul
                style={{
                  lineHeight: "1.5",
                  letterSpacing: "0.15px",
                  paddingLeft: "24px",
                }}
              >
                <li>
                  <Typography>
                    Completed at least <b>50 multifamily asset inspections</b>{" "}
                    comparable to Freddie Mac’s Property Inspections
                  </Typography>
                </li>
                <li>
                  <Typography>
                    At least{" "}
                    <b>2 years experience peforming multifamily inspections</b>{" "}
                    comparable to Freddie Mac’s Property Inspections
                  </Typography>
                </li>
                <li>
                  <Typography>Freddie Mac Approved Training</Typography>
                  <ul
                    style={{
                      lineHeight: "1.5",
                      letterSpacing: "0.15px",
                      paddingLeft: "24px",
                    }}
                  >
                    <li>
                      <Typography>
                        Mortgage Bankers Association of America Multifamily
                        Property Inspection Workshop
                      </Typography>
                    </li>
                    <li>
                      <Typography>
                        Fannie Mae’s Property Risk Management Training
                      </Typography>
                    </li>
                    <li>
                      <Typography>Other Equivalent Program</Typography>
                    </li>
                  </ul>
                </li>
              </ul>
              {formik.values.isCertifiedInspector && (
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>Freddie Mac Approved Training</InputLabel>
                  <Select
                    value={
                      formik.values.certificationMethod ||
                      freddieMacCertificationMethods?.[0]?.certificationMethod
                    }
                    onChange={(event) => {
                      if (props.onCertificationMethodChange) {
                        props.onCertificationMethodChange(
                          event.target.value as string
                        );
                      } else {
                        formik.setFieldValue(
                          "certificationMethod",
                          event.target.value
                        );
                        if (event.target.value !== "Other") {
                          formik.setFieldValue("otherCertificationMethod", "");
                        }
                      }
                    }}
                    label="Freddie Mac Approved Training"
                    size="small"
                    sx={{ backgroundColor: "white" }}
                  >
                    {freddieMacCertificationMethods.map((type: any) => (
                      <MenuItem
                        key={type.certificationMethod}
                        value={type.certificationMethod}
                      >
                        {type.displayName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              {formik.values.certificationMethod === "Other" && (
                <TextInput
                  name="otherCertificationMethod"
                  value={formik.values.otherCertificationMethod}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter Equivalent Program"
                  label="Enter Equivalent Program"
                  fullWidth
                  error={
                    formik.touched.otherCertificationMethod &&
                    Boolean(formik.errors.otherCertificationMethod)
                  }
                  helperText={
                    formik.touched.otherCertificationMethod &&
                    formik.errors.otherCertificationMethod
                      ? (formik.errors.otherCertificationMethod as string)
                      : ""
                  }
                  sx={{
                    mb: 2,
                    width: "100% !important",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                    },
                    "& .MuiFormHelperText-root": {
                      backgroundColor: "transparent",
                      margin: 0,
                      marginTop: 0.5,
                    },
                  }}
                  size="small"
                />
              )}
              {formik.values.isCertifiedInspector && (
                <Box>
                  {!uploadedCertificate &&
                    !formik.values.certificate &&
                    !selectedCertificateFile && (
                      <Box
                        sx={{
                          height: 80,
                          border: formik.errors.certificate
                            ? "1px solid red"
                            : "1px dashed rgba(0, 0, 0, 0.12)",
                          position: "relative",
                          backgroundColor: "white",
                          display: "flex",
                          alignItems: "center",
                          maxWidth: "1034px !important",
                        }}
                      >
                        <UploadFileIcon sx={{ ml: 5 }} color="primary" />
                        <Box ml={2}>
                          <Box sx={{ display: "flex" }}>
                            <Typography
                              color="primary"
                              sx={{
                                textDecoration: "underline",
                              }}
                            >
                              Click to upload
                            </Typography>
                            <Typography sx={{ ml: 1 }}>
                              or drag and drop
                            </Typography>
                          </Box>
                          <Typography
                            sx={{
                              color: "rgba(0, 0, 0, 0.6)",
                            }}
                          >
                            PDF, JPG or PNG (max. 10MB)
                          </Typography>
                        </Box>
                        <input
                          style={{
                            display: "block",
                            height: 80,
                            width: "100%",
                            position: "absolute",
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            opacity: 0,
                            cursor: "pointer",
                          }}
                          type="file"
                          accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/jpg,image/png"
                          onChange={handleCertificateFileChange}
                          name="certificate"
                          onClick={(event) => {
                            (event.target as HTMLInputElement).value = "";
                          }}
                        />
                      </Box>
                    )}
                  {(selectedCertificateFile ||
                    (formik.values.certificate &&
                      formik.values.certificate !==
                        data?.certificateFileName)) && (
                    <Box
                      sx={{
                        mt: 2,
                        maxWidth: "1034px !important",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        border: formik.errors.certificate
                          ? "1.5px solid red"
                          : "1.5px solid green",
                        p: 0.8,
                        borderRadius: 1,
                        backgroundColor: formik.errors.certificate
                          ? "#FFF5F5"
                          : "#F7FAF7",
                      }}
                    >
                      <Box display={"flex"} alignItems={"center"}>
                        <AttachFileOutlinedIcon color="primary" />
                        <Box sx={{ ml: 1.5 }}>
                          <Typography>
                            {selectedCertificateFile?.name ||
                              (formik.values.certificate instanceof File
                                ? formik.values.certificate.name
                                : formik.values.certificate) ||
                              "No file selected"}
                          </Typography>
                          <Typography>
                            {" "}
                            {selectedCertificateFile
                              ? `${(
                                  selectedCertificateFile.size / 1024
                                ).toFixed(2)} kb`
                              : formik.values.certificate instanceof File
                              ? `${(
                                  formik.values.certificate.size / 1024
                                ).toFixed(2)} kb`
                              : ""}
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        <IconButton
                          aria-label="delete"
                          onClick={handleCertificateFileDelete}
                        >
                          <RemoveCircleOutlineIcon color="error" />
                        </IconButton>
                      </Box>
                    </Box>
                  )}
                  {uploadedCertificate &&
                    !selectedCertificateFile &&
                    formik.values.certificate === data?.certificateFileName && (
                      <Box
                        sx={{
                          mt: 2,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          border: "1.5px solid green",
                          p: 0.8,
                          borderRadius: 1,
                          backgroundColor: "#F7FAF7",
                          maxWidth: "1034px !important",
                        }}
                      >
                        <Box display={"flex"} alignItems={"center"}>
                          <AttachFileOutlinedIcon color="primary" />
                          <Box sx={{ ml: 1.5 }}>
                            <Typography>{uploadedCertificate}</Typography>
                            <Typography
                              sx={{
                                color: "rgba(0, 0, 0, 0.6)",
                              }}
                            >
                              Complete
                            </Typography>
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <CheckCircleOutlineIcon
                            color="success"
                            sx={{ mr: 2 }}
                          />
                          <IconButton
                            aria-label="delete"
                            onClick={() => {
                              setUploadedCertificate("");
                              formik.setFieldValue("certificate", "");
                              if (data?.certificateFileName) {
                                setDeleteCertificate(true);
                              }
                            }}
                          >
                            <DeleteOutlinedIcon color="error" />
                          </IconButton>
                        </Box>
                      </Box>
                    )}
                  {formik.errors.certificate && (
                    <Typography sx={{ fontSize: 12, mt: 0.5 }} color="error">
                      {formik.errors.certificate as string}
                    </Typography>
                  )}
                </Box>
              )}
            </Box>
          )}
        </Box>
      </FormGroup>
    </Box>
  );
};

export default FreddieMac;
